import React, { useCallback } from 'react'
import { SxProps } from '@mui/material/styles'
import { TextField, MenuItem } from '@mui/material'
import { ArrowDown } from '@/icon'
import Text from '@/components/Text'
import { disabledText } from '@/constant'

export type SelectOptionProps = { label: string; value: string | number };

export interface SelectProps {
  value?: string | number | Array<string | number>;
  label?: string;
  required?: boolean;
  onChange?: (value: string | number | string[] | number[]) => void;
  options: SelectOptionProps[];
  placeholder?: string;
  multiple?: boolean;
  onFocus?: () => void;
  sx?: SxProps;
  error?: boolean;
  empty?: string;
  renderOption?: (v: SelectOptionProps) => React.ReactNode;
}

const Select: React.FC<SelectProps> = (props) => {
  const {
    value,
    onChange,
    label,
    options,
    required,
    placeholder,
    multiple,
    onFocus,
    sx,
    error,
    empty,
    renderOption,
  } = props

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onChange && onChange(event.target.value)
    },
    [onChange]
  )

  return (
    <TextField
      onFocus={onFocus}
      select
      error={error}
      variant="standard"
      label={label}
      value={value}
      required={required}
      onChange={handleChange}
      SelectProps={{ IconComponent: ArrowDown, multiple, placeholder }}
      sx={{ '& 	.MuiSelect-icon': { fontSize: '12px' }, ...sx }}
      placeholder={placeholder}
    >
      {options?.map((option, index) => (
        <MenuItem key={`select-option-${index}`} value={option.value}>
          {renderOption ? renderOption(option) : option.label}
        </MenuItem>
      ))}
      {options?.length === 0 && (
        <Text size="xs" sx={{ marginLeft: '16px', color: disabledText }}>
          {empty}
        </Text>
      )}
    </TextField>
  )
}

export * from './sortButton'
export default Select
